import { render, staticRenderFns } from "./BookOverview.vue?vue&type=template&id=48dae996&"
import script from "./BookOverview.vue?vue&type=script&lang=js&"
export * from "./BookOverview.vue?vue&type=script&lang=js&"
import style0 from "./BookOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports